module.exports = __webpack_public_path__ + "img/arrow-down-square-fill.03f33667.svg";